import {
  getDashboardPanelOptions,
  getDashboardPanels,
} from "../../services/assetServices";
import CountCardPanel from "./CountCardPanel";

const WorkOrdersCountCardPanel: React.FC = () => {
  const fetchOptionsFunction = async () => {
    const optionsResponse = await getDashboardPanelOptions(
      new AbortController(),
      "WorkOrdersCount"
    );
    const options = Object.entries(optionsResponse.values).map(
      ([name, value]) => ({
        key: name,
        text: value,
      })
    );
    return options;
  };

  const fetchDataFunction = async (status: string) => {
    return await getDashboardPanels(
      new AbortController(),
      "WorkOrdersCount",
      status
    );
  };

  return (
    <CountCardPanel
      label="Work orders"
      style={{ backgroundColor: "lavender" }}
      fetchOptionsFunction={fetchOptionsFunction}
      fetchDataFunction={fetchDataFunction}
    />
  );
};
export default WorkOrdersCountCardPanel;
